<template>
  <div>
    <div v-if="this.currentQuestion">
      <b-card class="fluid">
        <b-card-text align="center">
          <h4>{{ this.currentQuestion.text }}</h4>
          <div v-if="spr2_lookupTypeId(this.currentQuestion.typeId) === 'YesOrNo'">
           <div>
              <b-button size="lg" variant="outline-danger" :pressed="!this.currentAnswer && this.currentQuestion.answered" @click="currentAnswer=false;goNext()">No</b-button>
              <b-button size="lg" variant="outline-success" :pressed="this.currentAnswer && this.currentQuestion.answered" @click="currentAnswer=true;goNext()">Yes</b-button>
            </div>
          </div>
          <div v-if="spr2_lookupTypeId(this.currentQuestion.typeId) === 'TextInput'">
            <textarea rows="2" v-model="currentQuestion.textAnswer"></textarea>
          </div>
          <div v-if="spr2_lookupTypeId(this.currentQuestion.typeId) === 'Acknowledgement'">
            <div>
              <b-button variant="outline-primary" :pressed="currentQuestion.answer" @click="currentQuestion.answer=!currentQuestion.answer;goNext()">Acknowledge</b-button>
            </div>
          </div>
          <div v-if="spr2_lookupTypeId(this.currentQuestion.typeId) === 'Checklist'">
            <div class="row justify-content-md-center text-left my-4">
              <div class="col-xl-8 col-lg-10 col-md-12 col-12 text-left">
                <div class="list-group">
                  <b-form-checkbox class="list-group-item pl-5 checkbox-list" v-for="checklistItem in this.currentQuestion.checklistItems" v-bind:key="checklistItem.text" v-model="checklistItem.checked">{{checklistItem.text}}</b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </b-card-text>
      </b-card>
    </div>
  </div>
</template>
<script>
import { spr2Procedures } from '../mixins/Spr2SharedFunctions'
export default {
  mixins: [spr2Procedures],
  props: {
    questions: null,
    showIndex: 0
  },
  data: function () {
    return {
      currentQuestionStore: null,
      questionIdTrail: [],
      questionIndexTrailCurrentIndex: 0
    }
  },
  computed: {
    currentQuestion: {
      get: function () {
        return this.currentQuestionStore
      },
      set: function (val) {
        this.currentQuestionStore = val
      }
    },
    currentAnswer: {
      get: function () {
        return this.currentQuestion.answer
      },
      set: function (val) {
        this.currentQuestion.answer = val
        this.currentQuestion.answered = true
      }
    },
    nextQuestion () {
      var nextQuestionReturn = null
      var nextQuestionId = null
      var typeName = this.spr2_lookupTypeId(this.currentQuestion.typeId)
      if (
        this.currentQuestion.yesResult &&
        (typeName === 'TextInput' || typeName === 'Acknowledgement' || typeName === 'Checklist' || typeName === 'ImageUpload') &&
        this.currentQuestion.yesResult.type === 'goto'
      ) {
        nextQuestionId = this.currentQuestion.yesResult.value
        nextQuestionReturn = this.questions.find(
          (o) => o.id === nextQuestionId
        )
      } else if (
        this.currentQuestion.yesResult &&
        this.currentQuestion.answer === true &&
        this.currentQuestion.yesResult.type === 'goto'
      ) {
        nextQuestionId = this.currentQuestion.yesResult.value
        nextQuestionReturn = this.questions.find(
          (o) => o.id === nextQuestionId
        )
      } else if (
        this.currentQuestion.noResult &&
        this.currentQuestion.answer === false &&
        this.currentQuestion.noResult.type === 'goto'
      ) {
        nextQuestionId = this.currentQuestion.noResult.value
        nextQuestionReturn = this.questions.find(
          (o) => o.id === nextQuestionId
        )
      } else {
        nextQuestionReturn = null
      }
      return nextQuestionReturn
    }
  },
  watch: {
    questions: function (newVal, oldVal) {
      console.log('Questions got reset.....')
      this.currentQuestionStore = newVal[0]
      this.questionIdTrail = []
      this.questionIndexTrailCurrentIndex = 0
      this.questionIdTrail.push(this.currentQuestionStore.id)
    },
    showIndex: function (newVal, oldVal) {
      if (newVal > oldVal) {
        this.handleNext()
      } else {
        this.handlePrev()
      }
    }
  },
  methods: {
    handlePrev () {
      if (this.questionIndexTrailCurrentIndex > 0) {
        this.questionIndexTrailCurrentIndex--
        this.currentQuestion = this.questions.find(
          (o) =>
            o.id === this.questionIdTrail[this.questionIndexTrailCurrentIndex]
        )
        console.log(
          'QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2)
        )
        console.log(
          'QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex
        )
      }
    },
    goNext () {
      setTimeout(() => this.handleNext(), 200)
    },
    handleNext () {
      console.log(
        'QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2)
      )
      console.log(
        'QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex
      )
      if (this.nextQuestion) {
        this.currentQuestion = this.nextQuestion
        var found = this.questionIdTrail.find(
          (id) => id === this.currentQuestion.id
        )
        if (!found) {
          console.log(`pushing ${this.currentQuestion.id} to questionIdTrail`)
          this.questionIdTrail.push(this.currentQuestion.id)
          this.questionIndexTrailCurrentIndex++
        }
        console.log(
          'QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2)
        )
        console.log(
          'QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex
        )
      }
    }
  }
}
</script>
